<template>
  <div>
    <PageBanner :bannerObj="bannerObj"></PageBanner>

    <div class="main">
      <div class="content">
        <JournalCover></JournalCover>
        <div class="article-v">
          <ul class="nav">
            <li v-for="item in navList" :key="item.id" :class="{ selectedNav: curNav === item.id }"
                @click="handleNav(item)">
              {{ item.name }}
            </li>
          </ul>
          <div v-if="curNav === 2 && yearsIssueList.length > 0" class="year-periods">
            <div class="flex" style="border-bottom: 1px solid #e1e8f6">
              <p class="label">年度：</p>
              <ul class="year-list">
                <li v-for="item in yearsIssueList" :key="item['years']"
                    :class="{ 'select-year': curYear === item['years'] }" @click="handleYear(item)">
                  {{ item["years"] }}年
                </li>
              </ul>
            </div>
            <div class="flex">
              <p class="label">期数：</p>
              <ul class="periods-list">
                <li v-for="item in periodsList" :key="item" :class="{ 'select-periods': curPeriods === item }"
                    @click="handlePeriods(item)">
                  {{ item }}期
                </li>
              </ul>
            </div>
          </div>
          <!--        文章列表-->
          <Article v-if="curNav === 2 || curNav === 1" :articleList="articleList" :curNav="curNav"
                   :pageSize="form.pageSize" :total="total" @changePage="changePage"></Article>
          <!--        编委-->
          <EditorialBoard v-else-if="curNav === 3"></EditorialBoard>
          <!--        投稿须知-->
          <Instructions v-else-if="curNav === 4"></Instructions>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import JournalCover from "@/components/index/JournalCover"
import Article from "@/components/journal/Article.vue"
import EditorialBoard from "@/components/journal/EditorialBoard.vue"
import Instructions from "@/components/journal/Instructions.vue"
import PageBanner from "@/components/common/pageBanner.vue"

export default {
  metaInfo () {
    return {
      title: "广州统计师事务所",
      meta: [
        { name: "keywords", content: "广州统计师事务所" },
        { name: "description", content: "广州统计师事务所" },
        { name: "viewport", content: "width=device-width, initial-scale=0.1" },
      ],
    }
  },
  data () {
    return {
      bannerObj: {
        lableZh: "期刊介绍",
        lableEn: "JOURNAL INTRODUCTION",
        bannerImg: require("@/assets/img/journal/banner.png"),
      },
      curNav: 1,
      navList: [
        { name: "最新文章", id: 1 },
        { name: "历史文章", id: 2 },
        { name: "编委", id: 3 },
        { name: "投稿须知", id: 4 },
      ],
      curYear: "2025",
      curPeriods: "01",
      yearsIssueList: [],
      periodsList: [],
      articleList: [],
      total: 0,
      form: {
        pageNum: 1,
        pageSize: 10,
      },
    }
  },
  components: {
    PageBanner,
    Instructions,
    EditorialBoard,
    JournalCover,
    Article,
  },
  created () {
    this.getYearsIssue(() => {
      if (this.$route.query.curNav) {
        this.curNav = this.$route.query.curNav * 1
      }
      this.handleNav({ id: this.curNav })
    })
  },
  methods: {
    handleNav (item) {
      this.curNav = item.id
      if (item.id === 1) {
        // 最新
        this.changePage(1)
      } else if (item.id === 2) {
        // 历史
        if (this.yearsIssueList.length > 0) {
          this.handleYear(this.yearsIssueList[0])
        }
      }
    },
    // 年
    handleYear (item) {
      this.curYear = item["years"]
      if (item["issueList"].length > 0) {
        this.periodsList = item["issueList"]
        this.curPeriods = item["issueList"][0]
      } else {
        this.periodsList = []
        this.curPeriods = null
      }
      this.changePage(1)
    },
    handlePeriods (item) {
      this.curPeriods = item
      this.changePage(1)
    },
    // 年期
    getYearsIssue (callback) {
      this.$request.getYearsIssue().then((res) => {
        if (res.code === 200) {
          this.yearsIssueList = res.data
        }
        callback && callback()
      })
    },
    // 列表
    changePage (page) {
      this.form.pageNum = page
      this.$request
        .getJournalList({
          ...this.form,
          years: this.curNav === 2 ? this.curYear : null,
          issue: this.curNav === 2 ? this.curPeriods : null,
        })
        .then((res) => {
          if (res.code === 200) {
            this.articleList = res.rows
            this.total = res.total
          }
        })
    },
  },
};
</script>
<style lang="scss" scoped>
.banner {
  width: 100%;
  height: auto;
}

.main {
  background: #f7f7fd;

  .content {
    width: 1180px;
    padding: 30px 0 45px;
    margin: 0 auto;
  }

  .article-v {
    //height: 1385px;
    background: #ffffff;

    padding: 30px 0;
    margin-top: 30px;
  }

  .nav {
    margin: 0 50px;
    display: flex;
    align-items: center;

    li {
      width: 130px;
      height: 40px;
      background: #e1e8f6;
      border: 1px solid #e5e5e5;
      font-size: 16px;
      color: #333333;
      line-height: 40px;
      text-align: center;
      cursor: pointer;
      border-radius: 5px;
      font-weight: bold;

      &:not(:last-child) {
        margin-right: 20px;
      }

      &.selectedNav {
        background: #406cdd;
        border: 1px solid #ffffff;
        color: #ffffff;
      }
    }
  }

  .label {
    height: 25px;
    font-size: 16px;
    color: #000000;
    line-height: 25px;
    margin: 18px 0;
  }

  .year-periods {
    background: #ecf0f8;
    margin: 30px 50px 0;
    padding: 0 30px;
    border-radius: 5px;

    .year-list {
      flex: 1;
      display: flex;
      align-items: center;
      flex-flow: wrap;
      padding: 10px 0;

      li {
        width: 71px;
        height: 25px;
        margin: 8px 0 8px 25px;
        border-radius: 13px;
        font-size: 16px;
        color: #333333;
        line-height: 25px;
        text-align: center;
        cursor: pointer;

        &.select-year {
          background: #406cdd;
          color: #ffffff;
          font-weight: bold;
        }

        &:active {
          opacity: 0.7;
        }
      }
    }

    .periods-list {
      flex: 1;
      display: flex;
      align-items: center;
      flex-flow: wrap;
      padding: 10px 0;

      li {
        margin: 8px 0 8px 25px;
        background: none;
        font-size: 14px;
        color: #666666;
        cursor: pointer;

        &.select-periods {
          font-weight: bold;
          color: #406cdd;
        }

        &:active {
          opacity: 0.7;
        }
      }
    }
  }
}
</style>
